import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ToastrModule} from "ngx-toastr";


/**
 *<h3> @module NotificationModule
 * This module is responsible for handling the toastr notifications in the application.
 * @Imports: CommonModule, ToastrModule.forRoot()
 * @Exports: ToastrModule
 */
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right' // Set position to top-right
    }),
  ],
  exports: [
    ToastrModule
  ]
})
export class NotificationModule { }
